import { ProcessComponent, IProcessComponentProps } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { AdviserContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { ExternalDocumentType } from "../../../../../../../Wrap/Models/Domains/Documents/ExternalDocumentType";
import { ExternalFundDocument } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/ExternalFundDocument";
import * as React from "react";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";

export interface ICashProductDeclarationsProps extends React.Props<CashProductDeclarations>
{
    instrumentCodes: Array<string>;
    isCashDeclarationChecked: boolean;
    onCashDeclarationChanged: (newValue: boolean) => void;
}

export interface ICashProductDeclarationsState
{
    isTermsAndConditionsUrlLoading: boolean
    isPrivacyPolicyUrlLoading: boolean
    termsAndConditionsUrl: string;
    privacyPolicyUrl: string;
}

export class CashProductDeclarations extends React.Component<ICashProductDeclarationsProps, ICashProductDeclarationsState>
{
    constructor(props: ICashProductDeclarationsProps) {
        super(props);

        this.state =
            {
                isTermsAndConditionsUrlLoading: true,
                isPrivacyPolicyUrlLoading: true,
                termsAndConditionsUrl: null,
                privacyPolicyUrl: null
            };
    }

    public componentDidMount()
    {
        const client: ClientAccount = ClientAccountStore.getClientAccountInfo();

        const company: string = client?.Company ||
            AdviserContextStoreStatic.getData()?.Company;

        this.getDocumentUrl(
            ExternalDocumentType.BondsmithTermsAndConditions,
            company,
            (result: ExternalFundDocument) =>
            {
                this.setState(
                    {
                        isTermsAndConditionsUrlLoading: false,
                        termsAndConditionsUrl: result.Instruments[0].FinexDocumentUrl
                    })
            });

        this.getDocumentUrl(
            ExternalDocumentType.BondsmithPrivacyPolicy,
            company,
            (result: ExternalFundDocument) =>
            {
                this.setState(
                    {
                        isPrivacyPolicyUrlLoading: false,
                        privacyPolicyUrl: result.Instruments[0].FinexDocumentUrl
                    })
            });
    }

    private getDocumentUrl(
        externalDocType: ExternalDocumentType, company: string,
        callback: (val: ExternalFundDocument) => void): void
    {
        InstructionDocumentTypeRequestTriggerActionsCreator.getExternalFundDocument(
            0,
            "",
            company,
            externalDocType,
            [this.props.instrumentCodes[0]],
            callback);
    }

    public render(): JSX.Element
    {
        if (this.state.isTermsAndConditionsUrlLoading || this.state.isPrivacyPolicyUrlLoading)
        {
            return <PartLoading isLoading={true}></PartLoading>;
        }

        return (
            <>
                <h3 className="mb-7 h4">Cash deposits</h3>
                <p className="mb-10">
                    By ticking the box below, I confirm that
                    <ul style={{listStyleType: "upper-roman"}}>
                        <li>I have provided my client with Bondsmith’s End User&nbsp;
                            <a className="hyperlink"
                               target="_blank"
                               href={encodeURI(this.state.termsAndConditionsUrl)}
                               role="link"
                            >
                                terms and conditions
                            </a> and that my client agrees to be bound by them.</li>
                        <li>I have advised my client of Bondsmith’s&nbsp;
                            <a className="hyperlink"
                               target="_blank"
                               href={encodeURI(this.state.privacyPolicyUrl)}
                               role="link"
                            >
                                privacy notice
                            </a>.
                        </li>
                        <li>I have provided my client with the product information sheet(s) for the relevant cash deposit(s) and the FSCS information sheet. </li>
                        <li>I will continue to provide my client with any relevant information required under applicable laws and regulations.</li>
                        <li>My client meets the eligibility criteria set out in the Bondsmith End User terms and conditions. I will inform abrdn if this is no longer the case.</li>
                    </ul>
                </p>
                <div className="no-print">
                    <CheckboxEditor
                        value={this.props.isCashDeclarationChecked}
                        onChange={this.props.onCashDeclarationChanged}
                        label="Confirm"
                        required="required"
                        cssWrapper="square-checkbox block"
                    ></CheckboxEditor>
                </div>
                <p style={{fontSize: "12px"}}>* Orders will remain pending until the KYB process is complete, and
                    product selections may no longer be available at the time of completion.</p>
            </>
        );
    }
}
